<template>
  <el-select
    :value="selected"
    @input="dispatch"
    :placeholder="placeholder || $t('message.family_location')"
    filterable
    clearable
    :size="size"
    class="d-block"
    :class="mode ? 'input__day' : 'input__night'"
  >
    <el-option
      v-for="(familyStatus, index) in familyStatuses"
      :key="'familyStatus-' + index"
      :label="familyStatus.name"
      :value="familyStatus.id"
    >
    </el-option>
  </el-select>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "status",
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    table_name: {
      default: null,
      type: String,
      required: false,
    },
    id: {
      default: null,
    }
    
  },
  mounted() {
    if (this.familyStatuses){
        this.fetchFamilyStatuses();
    }
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    id: {
      handler: function () {
        this.selected = this.id;
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      familyStatuses: "familyStatus/inventory",
      mode:'MODE'
    }),
  },
  methods: {
    ...mapActions({
      updateInventory: "familyStatus/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);
      this.selected = e;
    },
    fetchFamilyStatuses() {
      const query = { table_name: this.table_name };
      this.updateInventory(query)
        .then((res) => {                       
          this.loadingData = false;
        })
        .catch((err) => {
          this.loadingData = false;
        });
    },
  },
};
</script>
